export default {
  changeLocale({ commit }, locale) {
    localStorage.setItem("locale", locale);
    commit("CHANGE_LOCALE", locale);
  },
};
